import { Injectable } from '@angular/core';

@Injectable()
export class TempStateService {
  oldUrl: string='';
  constructor() {}
}
